import { DynamicForm } from 'src/components';
import { SidePanelRowProps } from 'src/graphql/entities/side-panel-personalization';
import { ConversationDetailsFormValues } from 'src/pages/Conversations/SidePanel/ConversationDetails/use-conversation-properties-form';
import { useConversationPropertiesFormContext } from './conversation-properties-form-context';

function makeFormPropertyRow(fieldName: keyof ConversationDetailsFormValues) {
  const FormPropertyRow = (_props: SidePanelRowProps) => {
    const { fieldsByName, onSubmit } = useConversationPropertiesFormContext();
    const field = fieldsByName.get(fieldName);

    if (!field) {
      return null;
    }

    return (
      <DynamicForm<ConversationDetailsFormValues>
        watchable
        watchableSubmitOnlyChangedField
        fields={[field]}
        onSubmit={onSubmit}
      />
    );
  };

  FormPropertyRow.displayName = `ConversationPropertyRow(${fieldName})`;

  return FormPropertyRow;
}

export const StatusRow = makeFormPropertyRow('conversationStatus');

export const AssigneeRow = makeFormPropertyRow('assignee');

export const RequesterRow = makeFormPropertyRow('requester');

export const TypeRow = makeFormPropertyRow('type');

export const UrgencyRow = makeFormPropertyRow('urgency');
